<template>
  <b-row class="admin-login-page pt-5">
    <div v-if="isLoading" class="d-flex justify-content-center w-100"><loading-spinner/></div>
    <b-col v-else-if="$route.name === 'LogoutConfirm'" cols="12" md="6" offset-md="3">
      <p>{{ $t('auth.logout.title') }}</p>
      <p>{{ $t('auth.logout.message') }}</p>
      <p><a href="/login">{{ $t('auth.logout.retrigger') }}</a></p>
    </b-col>
    <b-col v-else cols="12" md="6" offset-md="3">
      <b-row>
        <b-col cols="12" class="mb-3 text-center">
          <b-img height="200" width="200" src="/static/images/logos/small-logo.png"/>
          <h3 v-if="currentHour >= 6 && currentHour < 12">Good morning!</h3>
          <h3 v-else-if="currentHour >= 12 && currentHour < 18">Good afternoon!</h3>
          <h3 v-else>Good evening!</h3>
        </b-col>
      </b-row>
      <b-card class="shadow px-1 px-md-5 py-1" body-class="text-center">
        <b-form-group v-if="user && user.emailAddress">
          <p class="mb-2">Last time you logged-in with:</p>
          <b-button class="btn-primary btn-sign-in w-100" :href="cognitoAuthUrl">
            <font-awesome-icon class="mr-1" :icon="[ 'fab', 'google' ]"/> {{ user.emailAddress }}
          </b-button>
          <b-form-text class="mt-2">
            <a href="/logout?next=/login">Or sign-in as someone else?</a>
          </b-form-text>
        </b-form-group>
        <b-form-group v-else>
          <p class="mb-2">Please login to continue:</p>
          <b-button class="btn-primary btn-sign-in w-100" :href="cognitoAuthUrl">
            <font-awesome-icon class="mr-1" :icon="[ 'fab', 'google' ]"/> Sign-in with Google
          </b-button>
          <b-form-text class="mt-2">Using your <strong>reallinks.io</strong> account</b-form-text>
        </b-form-group>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import LoadingSpinner from '@src/components/misc/LoadingSpinner';
import { cognitoAuth, getCognitoUser } from '@src/lib/admin';

export default {
  data: () => ({
    isLoading: false,
    user: null,
  }),
  components: {
    LoadingSpinner,
  },
  created() {
    try {
      this.user = getCognitoUser();
    } catch (err) {
      this.$log.error(err);
    }
  },
  async mounted() {
    try {
      this.isLoading = true;
      this.$log.info('getCognitoUser', JSON.stringify(this.user));

      if (this.$route.name === 'LoginConfirm') {
        await cognitoAuth.parseCognitoWebResponse(window.location.href);
        await this.finishLogin();
      } else if (this.$route.name === 'Logout') {
        await this.logout();
      } else if (cognitoAuth.isUserSignedIn()) {
        this.$router.replace({ name: 'Welcome' });
      } else if (cognitoAuth.getRefreshToken()) {
        // This means you are authenticated with Cognito but not with companyAuthenticate
        await this.resumeSession();
      } else {
        this.isLoading = false;
      }
    } catch (err) {
      this.$log.error(err);
      this.$notifyFatalErr(err);
      this.isLoading = false;
    }
  },
  metaInfo() {
    const meta = {
      title: 'Login',
      titleTemplate: '%s — Real Links Admin',
    };

    switch (this.$route.name) {
      case 'Logout': meta.title = 'Logging Out'; break;
      case 'LoginConfirm': meta.title = 'Logging In..'; break;
    }
    return meta;
  },
  computed: {
    currentHour: () => (new Date()).getHours(),
    cognitoAuthUrl: () => cognitoAuth.getFQDNSignIn(),
  },
  methods: {
    async resumeSession() {
      // Attempt to retrigger Cognito
      const refreshToken = cognitoAuth.getRefreshToken();
      await cognitoAuth.refreshSession(refreshToken); // @NOTE May trigger a redirect ending up at LoginConfirm!
      this.finishLogin();
    },
    finishLogin() {
      this.user = getCognitoUser();
      this.$log.debug('resumeCognitoSession', { user: this.user });
      this.$assert(this.user && this.user.emailAddress, new Error('Failed to find user from Cognito'));
      this.$assert(this.user.isValid, new Error('User is still not valid'));
      this.$router.push({ name: 'Welcome' });
    },
    async logout() {
      await cognitoAuth.signOut();

      const localStorage = 'localStorage' in global && global.localStorage ? global.localStorage : null;
      localStorage && localStorage.clear();

      const sessionStorage = 'sessionStorage' in global && global.sessionStorage ? global.sessionStorage : null;
      sessionStorage && sessionStorage.clear();
    }
  },
};
</script>

<style lang="scss">
.admin-login-page {
  .btn-sign-in {
    background-color: transparent;
    border-color: #4453a6;
    color: #4453a6;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Admin/Auth.vue